(function () {
  var scriptEl = document.currentScript;
  var showDuration = parseFloat(scriptEl.getAttribute('data-sp-show-duration')) || 4;
  var gapDuration = parseFloat(scriptEl.getAttribute('data-sp-gap-duration')) || 5;
  var startDelay = parseFloat(scriptEl.getAttribute('data-sp-start-delay')) || 3;

  function randomTimeText() {
    var roll = Math.random();
    if (roll < 0.7) {
      var mins = Math.floor(Math.random() * 58) + 1; // 1-58 minutes
      return mins + (mins === 1 ? ' minute ago' : ' minutes ago');
    } else if (roll < 0.95) {
      var hours = Math.floor(Math.random() * 5) + 1; // 1-5 hours
      return hours + (hours === 1 ? ' hour ago' : ' hours ago');
    }
    return 'just now';
  }

  function pickRandom(arr, avoidValue) {
    if (arr.length === 0) return null;
    if (arr.length === 1) return arr[0];
    var pick;
    do {
      pick = arr[Math.floor(Math.random() * arr.length)];
    } while (pick === avoidValue && arr.length > 1);
    return pick;
  }

  function init() {
    var wraps = document.querySelectorAll('[id^="sp-"]');
    if (wraps.length === 0) {
      console.warn('[sales-popup] No element with id starting "sp-" found on the page.');
      return;
    }

    wraps.forEach(function (wrap) {
      var card = wrap.querySelector('[data-sp-card]');
      var closeBtn = wrap.querySelector('[data-sp-close]');
      var imgEl = wrap.querySelector('[data-sp-image]');
      var customerEl = wrap.querySelector('[data-sp-customer]');
      var productEl = wrap.querySelector('[data-sp-product]');
      var timeEl = wrap.querySelector('[data-sp-time]');
      var jsonEl = wrap.querySelector('[data-sp-json]');

      if (!card) {
        console.error('[sales-popup] .sp-card element not found inside', wrap);
        return;
      }
      if (!jsonEl) {
        console.error('[sales-popup] data-sp-json script tag not found inside', wrap);
        return;
      }

      var data;
      try {
        data = JSON.parse(jsonEl.textContent);
      } catch (e) {
        console.error('[sales-popup] Failed to parse JSON data. Check the data-sp-json script tag content for invalid JSON (missing quotes/commas):', e, jsonEl.textContent);
        return;
      }

      var customers = (data.customers || []).filter(Boolean);
      var products = (data.products || []).filter(function (p) { return p && p.title; });

      if (customers.length === 0) {
        console.error('[sales-popup] No customers found in JSON data. Add names in the section\'s "Customer names" textarea.');
        return;
      }
      if (products.length === 0) {
        console.error('[sales-popup] No products found in JSON data. Add at least one Product block with a title in the theme editor.');
        return;
      }

      var lastCustomer = null;
      var lastProduct = null;
      var hideTimeoutId = null;
      var nextTimeoutId = null;

      function showCurrent() {
        var customer = pickRandom(customers, lastCustomer);
        var product = pickRandom(products, lastProduct);
        lastCustomer = customer;
        lastProduct = product;

        imgEl.src = product.image || '';
        imgEl.alt = product.title || '';
        customerEl.textContent = customer;
        productEl.textContent = product.title;
        timeEl.textContent = randomTimeText();

        card.classList.add('is-visible');

        hideTimeoutId = setTimeout(function () {
          card.classList.remove('is-visible');
          scheduleNext(gapDuration);
        }, showDuration * 1000);
      }

      function scheduleNext(delaySeconds) {
        nextTimeoutId = setTimeout(showCurrent, delaySeconds * 6000);
      }

      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          clearTimeout(hideTimeoutId);
          clearTimeout(nextTimeoutId);
          card.classList.remove('is-visible');
          scheduleNext(gapDuration);
        });
      }

      console.log('[sales-popup] Initialized with', customers.length, 'customers and', products.length, 'products. First popup in', startDelay, 'seconds.');
      scheduleNext(startDelay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();